import React, { FunctionComponent } from 'react';

import { SettingsEnableDisable } from '@components/settings/shared/settings-enable-disable';

interface ShowTagsProps {
  defaultEnabled: boolean | null;
}

const ShowTags: FunctionComponent<ShowTagsProps> = ({ defaultEnabled }) => (
  <SettingsEnableDisable
    defaultEnabled={defaultEnabled === null ? true : defaultEnabled}
    description={bfTranslate('Only applies to assets in Collections and Share Links')}
    errorTitle={bfTranslate('Error updating tags viewing permissions. Please contact support.')}
    id="show-tags"
    successTitle={bfTranslate('Tags viewing permissions updated!')}
    title={bfTranslate('Allow guest and public users to see tags')}
    updateResourceKey="showTags"
  />
);

export default ShowTags;
